"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IconGlyphs = [
    'account-minus-outline',
    'account-multiple-outline',
    'account-multiple-plus-outline',
    'account-outline',
    'account-plus-outline',
    'airplane-variant',
    'airplane',
    'alert-circle-outline',
    'alert-outline',
    'application-cog',
    'apps',
    'archive-arrow-up-outline',
    'archive-outline',
    'arrow-back-ios',
    'arrow-collapse',
    'arrow-down-bold-circle-outline',
    'arrow-down',
    'arrow-expand-all',
    'arrow-expand',
    'arrow-forward-ios',
    'arrow-left',
    'arrow-right-bold-outline',
    'arrow-right',
    'arrow-up-bold-circle-outline',
    'arrow-up',
    'at',
    'backspace-outline',
    'basketball',
    'beach-umbrella-outline',
    'bell-off-outline',
    'bell-outline',
    'bell-ring-outline',
    'bluetooth',
    'book-lock-outline',
    'book-outline',
    'bookmark-outline',
    'bookmark',
    'brand-gitlab',
    'brand-google',
    'brand-office-365',
    'brand-one-login',
    'brand-zoom',
    'bullhorn-outline',
    'calendar-check-outline',
    'calendar-month-outline',
    'calendar-outline',
    'camera-outline',
    'cancel',
    'car-outline',
    'cellphone',
    'chart-bar',
    'chart-line',
    'check-all',
    'check-circle-outline',
    'check-circle',
    'check',
    'checkbox-blank-outline',
    'checkbox-marked',
    'checkbox-multiple-marked-outline',
    'chevron-down-circle-outline',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'circle-multiple-outline-lock',
    'circle-multiple-outline',
    'circle-outline',
    'clock-outline',
    'clock-send-outline',
    'clock',
    'close-circle-outline',
    'close-circle',
    'close',
    'closed-caption-outline',
    'code-block',
    'code-brackets',
    'code-tags',
    'cog-outline',
    'console',
    'content-copy',
    'creation-outline',
    'credit-card-outline',
    'crown-outline',
    'currency-usd',
    'dock-left',
    'dock-window',
    'dots-horizontal',
    'dots-vertical',
    'download-outline',
    'drag-vertical',
    'draw',
    'element-of',
    'email-outline',
    'email-plus-outline',
    'email-variant',
    'emoticon-custom-outline',
    'emoticon-happy-outline',
    'emoticon-outline',
    'emoticon-plus-outline',
    'equal',
    'exclamation-thick',
    'exit-to-app',
    'export-variant',
    'eye-off-outline',
    'eye-outline',
    'file-audio-outline-large',
    'file-audio-outline',
    'file-code-outline-large',
    'file-code-outline',
    'file-excel-outline-large',
    'file-excel-outline',
    'file-generic-outline-large',
    'file-generic-outline',
    'file-gif',
    'file-image-broken-outline-large',
    'file-image-broken-outline',
    'file-image-outline-large',
    'file-image-outline',
    'file-multiple-outline-large',
    'file-multiple-outline',
    'file-patch-outline-large',
    'file-patch-outline',
    'file-pdf-outline-large',
    'file-pdf-outline',
    'file-powerpoint-outline-large',
    'file-powerpoint-outline',
    'file-text-outline-large',
    'file-text-outline',
    'file-video-outline-large',
    'file-video-outline',
    'file-word-outline-large',
    'file-word-outline',
    'file-zip-outline-large',
    'file-zip-outline',
    'filter-variant',
    'fire',
    'flag-checkered',
    'flag-outline',
    'flag',
    'flask-outline',
    'folder-move-outline',
    'folder-outline',
    'folder-plus-outline',
    'food-apple',
    'food-fork-drink',
    'format-bold',
    'format-clear',
    'format-header-1',
    'format-header-2',
    'format-header-3',
    'format-header-4',
    'format-header-5',
    'format-header-6',
    'format-header',
    'format-italic',
    'format-letter-case',
    'format-list-bulleted',
    'format-list-numbered',
    'format-quote-open',
    'format-strikethrough-variant',
    'forum-outline',
    'function',
    'gfycat',
    'github-circle',
    'glasses',
    'globe-checked',
    'globe',
    'hammer',
    'hand-right-outline-off',
    'hand-right-outline',
    'hand-right',
    'headphones',
    'heart-outline',
    'help-circle-outline',
    'help',
    'home-variant-outline',
    'icon-brand-giphy',
    'iframe-list-outline',
    'image-area-outline',
    'image-broken-outline',
    'image-outline',
    'import',
    'infinity',
    'information-outline',
    'kanban',
    'key-variant-circle',
    'key-variant',
    'keyboard-outline',
    'keyboard-return',
    'laptop',
    'layers-outline',
    'leaf-outline',
    'leaf',
    'lightbulb-outline',
    'lightning-bolt-outline',
    'link-variant-off',
    'link-variant',
    'lock-outline',
    'lock',
    'logout-variant',
    'magnify-minus',
    'magnify-plus',
    'magnify',
    'map-marker-outline',
    'mark-as-unread',
    'mattermost',
    'menu-down',
    'menu-left',
    'menu-right',
    'menu-up',
    'menu-variant',
    'menu',
    'message-arrow-right-outline',
    'message-check-outline',
    'message-check',
    'message-minus-outline',
    'message-plus-outline',
    'message-text-outline',
    'microphone-off',
    'microphone-outline',
    'microphone',
    'minus-box',
    'minus-circle-outline',
    'minus-circle',
    'minus',
    'monitor-account',
    'monitor-off',
    'monitor-share',
    'monitor',
    'not-equal-variant',
    'notebook-outline',
    'oauth',
    'open-in-new',
    'palette-outline',
    'paperclip',
    'pause',
    'pencil-outline',
    'phone-hangup',
    'phone-in-talk',
    'phone-outline',
    'phone',
    'pin-outline',
    'pin',
    'play-box-multiple-outline',
    'play-outline',
    'play',
    'playlist-check',
    'plus-box-outline',
    'plus-box',
    'plus',
    'pound',
    'power-plug-outline',
    'product-boards',
    'product-channels',
    'product-playbooks',
    'products',
    'radiobox-blank',
    'radiobox-marked',
    'record-circle-outline',
    'record-square-outline',
    'refresh',
    'reply-outline',
    'resize-bottom-right',
    'restore',
    'robot-happy',
    'search-list',
    'send-outline',
    'send',
    'server-outline',
    'server-variant-plus',
    'server-variant',
    'settings-outline',
    'share-variant-outline',
    'shield-alert-outline',
    'shield-outline',
    'shuffle-variant',
    'sitemap',
    'slash-forward-box-outline',
    'slash-forward',
    'soccer',
    'sort-alphabetical-ascending',
    'sort-ascending',
    'source-branch',
    'source-pull',
    'square',
    'star-outline',
    'star',
    'sync',
    'table-column-plus-after',
    'table-column-plus-before',
    'table-column-remove',
    'table-large',
    'table-plus',
    'table-remove',
    'table-row-plus-after',
    'table-row-plus-before',
    'table-row-remove',
    'table-settings',
    'tablet',
    'text-box-outline',
    'thumbs-up-down',
    'timeline-text-outline',
    'trash-can-outline',
    'tune',
    'update',
    'upload-outline',
    'video-off-outline',
    'video-outline',
    'view-grid-plus-outline',
    'volume-high',
    'webhook-incoming',
    'webhook-outgoing',
    'webhook',
];
exports.default = IconGlyphs;
